module.exports = "<li v-el:v v-if=\"loading\"><slot></slot></li>";


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./src/Option.vue
// module id = 242
// module chunks = 0